import { render, staticRenderFns } from "./ProjectTotalList.vue?vue&type=template&id=a8828e28&scoped=true"
import script from "./ProjectTotalList.vue?vue&type=script&lang=js"
export * from "./ProjectTotalList.vue?vue&type=script&lang=js"
import style0 from "./ProjectTotalList.vue?vue&type=style&index=0&id=a8828e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8828e28",
  null
  
)

export default component.exports